import {
  OnboardingItem,
  OnboardingTarget,
} from '@epicuro-next/constants/rule-engine/onboarding-rules';
import { createReducer, on } from '@ngrx/store';

import * as OnboardingActions from './onboarding.actions';

export const onboardingFeatureKey = 'onboarding';

export const ONBOARDING_STORAGE_KEY_VALUE = 'onboarding_storage';
export const ONBOARDING_VIEWED_VALUE_KEY = 'viewed';

export interface State {
  [ONBOARDING_VIEWED_VALUE_KEY]: boolean;
  enabled: boolean;
  [OnboardingTarget.SalesRep]?: OnboardingItem[];
  [OnboardingTarget.Consumer]?: OnboardingItem[];
  active?: OnboardingTarget | null;
  hideNeoclesLogo?: boolean;
  hideTenantLogo?: boolean;
}

export const initialState: State = {
  [ONBOARDING_VIEWED_VALUE_KEY]: false,
  enabled: false,
};

export const reducer = createReducer(
  initialState,
  on(
    OnboardingActions.setOnboardingConfiguration,
    (state, { consumer, sales }) => ({
      ...state,
      consumer,
      sales,
      enabled: true,
    }),
  ),
  on(OnboardingActions.setActiveOnboarding, (state, { target }) => ({
    ...state,
    active: target ?? null,
  })),
  on(OnboardingActions.setOnboardingViewed, (state) => ({
    ...state,
    viewed: true,
  })),
);
